module.exports = __webpack_public_path__ + "img/43.06f54617.gif";